module.exports = __webpack_public_path__ + "img/mgh-kyoto-kawaramachi-jokyoji-sp@2x.c3f4339e.jpg";